class StartedSubWave {
    public started: number;
    public generated: number;
    public dead:number;
    

    public proto: SubWave;
    public onDone = new Signal<(sub: StartedSubWave) => void>();
    public distribGen: () => number;

    constructor(proto: SubWave) {
        this.proto = proto;
        this.started = Game.millisecondsAbsolute;
        this.generated = 0;
        this.dead = 0;
        this.distribGen = DnDUtils.getDiceGenerator(proto.distrib);
    }

    public update(ms: number) {
        let max = this.proto.count;
        if (this.generated >= max) {
            return;
        }

        let length = this.proto.lengthSec * 1000;
        let timePsrt:number
        if (length) {
            timePsrt = (ms - this.started) / length;
        } else {
            timePsrt = 1;    
        }
        let generatedPart: number;

        generatedPart = this.generated / max;

        while (generatedPart < timePsrt && this.generated < max) {
            this.generateMonster();
            generatedPart = this.generated / max;
        }
    }

    private generateMonster(): void {
        let y = (this.distribGen() / 1000) * App.screen.height;
        let actorName = this.proto.actor;
        
        this.generated++;
        
        let mob = Game.spawnMob(Game.dicts[actorName], y);
        
        mob.once('dead', ()=>{
            this.dead++;
            if (this.dead >= this.proto.count) {
                this.onDone.emit(this);
            }
        });

        //PandaConsole.logDebug('Spawned: ' + actorName);
    }
}